import React, {useState, useEffect} from 'react';
import {IFdProductionCost, ISupplierUserProfile} from 'constants/interfaces';
import {
  reduxToggleSidePanel,
  reduxSetSidePanelEditState,
} from 'appredux/actions';
import {
  FdProductionCostForm,
  Submission,
} from 'components/applications/FdProductionCostForm';
import {apiUpsertFdProductionCost} from 'constants/Api';

const AddOrUpdateFdProductionCost = (props: {
  user: ISupplierUserProfile;
  productionCost?: IFdProductionCost;
  cropId: number;
  applicationId: number;
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [hasSuccessfullyUpdated, setHasSuccessfullyUpdated] = useState(false);

  const isAdding = !props.productionCost?.id;

  const handleCancel = () => reduxToggleSidePanel(false, null);

  const handleSubmit = (submission: Submission) => {
    setIsLoading(true);
    apiUpsertFdProductionCost({
      id: parseInt(props.productionCost?.id || submission.id) || undefined,
      applicationId: props.applicationId,
      cropId: props.cropId || parseInt(props.productionCost?.crop?.id!),
      plantingDate: submission.plantingDate,
      year: submission.year,
      numberOfHectares: submission.numberOfHectares,
      seed: submission.seed,
      fertiliser: submission.fertiliser,
      chemical: submission.chemical,
      notes: submission.notes ?? '',
    })
      .then(() => {
        setHasSuccessfullyUpdated(true);
        // Immediately signal that a save has occurred to trigger data refresh
        reduxSetSidePanelEditState('saved');
      })
      .catch((err) => {
        alert(
          'Failed to update production cost at the moment. Please try again later',
        );
        console.error('Failed to update production cost', err);
      })
      .finally(() => setIsLoading(false));
  };

  const canWrite = true;

  // Signal edit started on mount
  useEffect(() => {
    reduxSetSidePanelEditState('editing');
    return () => {
      // reset when panel unmounts if not saved
      reduxSetSidePanelEditState('idle');
    };
  }, []);

  // Close panel after successful update
  useEffect(() => {
    if (hasSuccessfullyUpdated) {
      // Close the side panel after a short delay to allow data refresh
      setTimeout(() => {
        reduxToggleSidePanel(false, null);
      }, 100);
    }
  }, [hasSuccessfullyUpdated]);

  if (hasSuccessfullyUpdated) return null;

  return (
    <FdProductionCostForm
      productionCost={props.productionCost}
      isLoading={isLoading}
      submitButtonTitle={isAdding ? 'Add' : 'Update'}
      onSubmit={handleSubmit}
      cancelButtonTitle="Cancel"
      onCancel={handleCancel}
      readonly={!canWrite}
    />
  );
};

export default AddOrUpdateFdProductionCost;
